/**
 * VF Bingo Balances Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var virtueFusionService = require('modules/services/vf.service');
    var BingoBonusView = require('replacers/bingo-replacers/bingo-bonus.view');

    module.exports = BingoBonusView.extend({

        getBalance: function() {
            var typeName = {
                'bingobonus': 'Bingo Bonus',
                'gamesbonus': 'Bingo Side Games Bonus',
                'sabingobonus': 'SA Bingo Bonus'

            }[this.options.name];

            virtueFusionService
                .getBalance({
                    balanceType: typeName,
                    correlationId: this.options.name
                })
                .done(this.onSuccess.bind(this))
                .fail(this.onError.bind(this));
        }

    }, {
        nameOfReplacers: [
            'BINGO_BONUS',
            'GAMES_BONUS',
            'SA_BINGO_BONUS'
        ]
    });
});
